import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Order } from '@cemex-core/cmx-api';
import { Store } from '@ngrx/store';
import { OneClickPreviewField } from '@ordersnproducts/modules/one-click-order/util/constants/preview-fields';
import * as moment from 'moment';
import { map, take } from 'rxjs/operators';
import { ConfigurableFormComponent } from '../../../shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '../../../shared/modules/configurable-form/models/on-field-changed';
import { OneClickUpdateOrderAction } from '../../actions/one-click-orders.actions';
import { State } from '../../reducers';
import { getOneClickSelectedOrder } from '../../selectors/one-click-orders.selector';

@Injectable()
export class OneClickSetRequestedDateTime implements OnFieldChanged {
  constructor(private store: Store<State>) {}

  onFieldChanged(value: string, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    if (value) {
      this.store
        .select(getOneClickSelectedOrder)
        .pipe(
          take(1),
          map((order) => ({ order })),
        )
        .subscribe(({ order }) => {
          const modded: Order = {
            ...order,
            items: order.items.map((item, index) => {
              if (index === form.mapItem['index']) {
                const timeString = moment(value).format('HH:mm:ss');
                if (
                  formGroup.get(OneClickPreviewField.DeliveryDate) &&
                  formGroup.get(OneClickPreviewField.DeliveryDate).value
                ) {
                  return {
                    ...item,
                    requestedDateTime:
                      moment(formGroup.get(OneClickPreviewField.DeliveryDate).value).format('YYYY-MM-DD') +
                      'T' +
                      timeString,
                  };
                }
                return {
                  ...item,
                  requestedDateTime: moment(value).format('YYYY-MM-DD') + 'T' + timeString,
                };
              } else {
                return item;
              }
            }),
          };

          this.store.dispatch(new OneClickUpdateOrderAction(modded));
        });
    }
  }
}
